require('./retailLoanCatalog.scss');

//@vendor
const React = require('react');
const isEqual = require('lodash/lang/isEqual');
const PropTypes = require('prop-types');
//@core
const { FormattedText, formatText } = require('core/i18n').i18n;

//@const
const {
    configOkLoans,
    retailLoanCommons: { SPLIT_RETAIL_PRODUCTS }
} = require('../../../../loansConstants/index');
const { EURO_SYMBOL } = require('constants/index');

//@components
const { RetailLoanCatalogItem } = require('../retailLoanCatalogItem/retailLoanCatalogItem');
const RetailLoanProductInfo = require('../retailLoanProductInfo/retailLoanProductInfo');

//@helpers
const { getPublicSitePath } = require('core/apiURLBuilder');
const { buildLoadCatalogRetailLoanView, splitIntoChunks } = require('../../../../loansUtilities/loansHelper');

//@utilities
const {
    recordProcess,
    PROC_CONTRACT_RETAIL_LOAN,
} = require('utilities/tagging');

class RetailLoanCatalog extends React.Component {

    componentDidMount() {
        const { immRetailLoan } = this.props;
        if (immRetailLoan.get('products').size > 0) {
            const customDataEvent = buildLoadCatalogRetailLoanView(immRetailLoan);
            const customData = {
                ...customDataEvent,
                event_name: "step_list",
                pageName: "/openMarketsInformation/step0/list",
                sectionFamily: "banking",
                sectionCategory: "products",
                sectionName: "loans",
                serviceType: "productContracting",
                interactionType: "funnel",
                processType: "openMarketsInformation",
                processStep: "step0",
                processDetail: "list",
                productName: "openMarkets",
            };
            recordProcess(PROC_CONTRACT_RETAIL_LOAN, null, customData, true);
        }
    }

    buildTopHighlightText() {
        return (<FormattedText value="retailLoanCatalogItem-topHighlightText" injectedStrings={[EURO_SYMBOL]} />)
    }


    buildCatalogItem() {
        const { setPurpose, showInfoProduct, setDeliveryDate,
            immRetailLoan, getTermConditionDocuments, setAgree,
            validateAgreeCheckBoxModal, resetDocumentsAndAgreeCheckBox,
            onPrintDocument, onDownloadDocumentTermCondition, immAccounts, setRetailLoanAccountsInactive } = this.props;

        const products = immRetailLoan.get('products');
        const catalogItemId = immRetailLoan.get('catalogItemId');
        const currency = immRetailLoan.get('currency');

        if (!isEqual(products.size, 0)) {
            // group in two
            const items = splitIntoChunks(products, SPLIT_RETAIL_PRODUCTS).map((group, rowIndex) => {
                const row = group.map((item, id) => {
                    const showModal = catalogItemId === item.get('nid');
                    const highlightText = this.buildTopHighlightText();

                        return (
                            <div key={id} className="retail-loan-catalog__item">
                                <RetailLoanCatalogItem
                                    index={id}
                                    itemProduct={item}
                                    highlightText={highlightText}
                                    setPurpose={setPurpose}
                                    showInfoProduct={showInfoProduct}
                                    setDeliveryDate={setDeliveryDate}
                                    labels={configOkLoans(
                                        formatText,
                                        item,
                                        currency
                                    )}
                                    termsAndConditionsUrl={getPublicSitePath(
                                        "termsAndConditions"
                                    )}
                                    showModal={showModal}
                                    currency={currency}
                                    immRetailLoan={immRetailLoan}
                                    getTermConditionDocuments={
                                        getTermConditionDocuments
                                    }
                                    setAgree={setAgree}
                                    validateAgreeCheckBoxModal={
                                        validateAgreeCheckBoxModal
                                    }
                                    resetDocumentsAndAgreeCheckBox={
                                        resetDocumentsAndAgreeCheckBox
                                    }
                                    onPrintDocument={onPrintDocument}
                                    onDownloadDocumentTermCondition={
                                        onDownloadDocumentTermCondition
                                    }
                                    immAccounts={immAccounts}
                                    setRetailLoanAccountsInactive={
                                        setRetailLoanAccountsInactive
                                    }
                                />
                            </div>
                        );
                });

                return (
                    <div key={`items-row-${rowIndex}`} className="row retail-loan-catalog__equalheight">
                        {row}
                    </div>
                );
            });

            return (
                <div className="retail-loan-catalog__row">
                    {items}
                </div>
            );
        } else {
            return null;
        }
    }

    buildInfoProduct() {
        const {
            getTermConditionDocuments,
            immRetailLoan,
            onDownloadDocumentTermCondition,
            onPrintDocument,
            resetDocumentsAndAgreeCheckBox,
            resetLoanPorpuse,
            setAgree,
            setDeliveryDate,
            setPurpose,
            showInfoProduct,
            validateAgreeCheckBox,
            validateAgreeCheckBoxModal,
        } = this.props;
        const selectedItemId = immRetailLoan.get('purpose');
        const immProducts = immRetailLoan.get('products');
        const currency = immRetailLoan.get('currency');
        const immSelectedItem = immProducts.find(immItem => selectedItemId === immItem.get('nid'));
        const highlightText = this.buildTopHighlightText();
        
        return immSelectedItem ? (
            <div className="row">
                <RetailLoanProductInfo
                    immRetailLoan={immRetailLoan}
                    immItem={immSelectedItem}
                    labels={configOkLoans(formatText, immSelectedItem, currency)}
                    setDeliveryDate={setDeliveryDate}
                    showInfoProduct={showInfoProduct}
                    resetLoanPorpuse={resetLoanPorpuse}
                    getTermConditionDocuments={getTermConditionDocuments}
                    setAgree={setAgree}
                    validateAgreeCheckBox={validateAgreeCheckBox}
                    validateAgreeCheckBoxModal={validateAgreeCheckBoxModal}
                    setPurpose={setPurpose}
                    resetDocumentsAndAgreeCheckBox={resetDocumentsAndAgreeCheckBox}
                    onPrintDocument={onPrintDocument}
                    onDownloadDocumentTermCondition={onDownloadDocumentTermCondition}
                    highlightText={highlightText}
                />
            </div>
        ) : null;
    }

    render() {
        const { immRetailLoan } = this.props;
        const showInfoProduct = immRetailLoan.get('showInfoProduct');
        const products = showInfoProduct ? this.buildInfoProduct() : this.buildCatalogItem();

        return (
            <div className="retail-loan-catalog">
                <div className="retail-loan-catalog__content">
                    {products}
                </div>
                <footer className="retail-loan-catalog__footer">
                    <FormattedText value="retailLoanCatalog-disclaimer" />
                </footer>
            </div>
        );
    }

}

RetailLoanCatalog.propTypes = {
    getSegmentedLoanProducts: PropTypes.func.isRequired,
    getTermConditionDocuments: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immRetailLoan: PropTypes.object.isRequired,
    onDownloadDocumentTermCondition: PropTypes.func.isRequired,
    onPrintDocument: PropTypes.func.isRequired,
    resetDocumentsAndAgreeCheckBox: PropTypes.func.isRequired,
    resetLoanPorpuse: PropTypes.func.isRequired,
    setAgree: PropTypes.func.isRequired,
    setDeliveryDate: PropTypes.func.isRequired,
    setPurpose: PropTypes.func.isRequired,
    setRetailLoanAccountsInactive: PropTypes.func.isRequired,
    showInfoProduct: PropTypes.func.isRequired,
    validateAgreeCheckBox: PropTypes.func.isRequired,
    validateAgreeCheckBoxModal: PropTypes.func.isRequired,
};


module.exports = RetailLoanCatalog;
